<template>

    <v-app v-if="isAuthenticated()" id="main">
        <v-app-bar height="80" app>
            <router-link :to="{name: 'main'}">
                <v-img alt="Logo" contain src="@/assets/ravenpod-text.png" transition="scale-transition" width="150"/>          
            </router-link>
            <v-tabs v-model="tab" background-color="grey lighten-4" centered>
                <v-tab :to="{name: 'businessTransactionTracking'}">Business Transaction Analysis</v-tab>
                <v-tab :to="{name: 'problemDeterminationDashboard'}">Problem Determination</v-tab>
            </v-tabs>          
            <v-btn :to="{name: 'profile'}" text>
                <v-avatar class="mr-2" size="32">
                    <amplify-s3-image class="avatar-small" :img-key="currentUserProfilePictureURL() ? currentUserProfilePictureURL() : 'default-user-profile-picture.png'" />
                </v-avatar>
                {{ currentUserName() }}
            </v-btn>
            <v-btn @click.prevent="logout" text><v-icon class="mr-1">mdi-logout</v-icon>Logout</v-btn>                          
        </v-app-bar>

        <v-main>        
            <v-container fluid>
                <router-view/>
            </v-container>
        </v-main>
    </v-app>

</template>

<script>
    export default {
        
        components: {
        },

        mounted: function () {
        },

        computed: {
        },

        created() {
        },

        methods: {
            
        },

        data: () => ({
            tab: 1,
        }),

    }
</script>

<style scoped lang="scss">
amplify-s3-image.avatar-small {
    --height: 32px;
    --width: 32px;
}
</style>